import { styled, Typography, TypographyProps } from '@mui/material'
import { ComponentType } from 'react'

export const AdornmentTypography: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	[ theme.breakpoints.down( 'sm' ) ]: {
		display: 'none',
	},
} ) )
